export const LANG = 'he';




// WEBPACK FOOTER //
// ./src/locale.js